module.exports = __webpack_public_path__ + "img/scott-graham-5fNmWej4tAA-unsplash.1d42579b.jpg";